import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-emp-complaint',
  templateUrl: './emp-complaint.component.html',
  styleUrls: ['./emp-complaint.component.css']
})
export class EmpComplaintComponent implements OnInit {
 
  title = "Employee Complaint Details";
  
  EmployeeComplaintDetails: any = [];
  data : any = {};
  userName: any;
  ItemsPerPage: number = 5;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  pageno: number = 1;
  l: any;
  b: any = [];
  EMP_EMPLOYEE_ID: any;
  mode: any;
  hide: boolean;
  COMPLAINT_ID: any;
  empId: any;
  EmployeeId: number;
  formInvalid: boolean;
  EMP_ID: any;
  reply: any;
  v : any = {};
  EmpID: any;
  Reply_Comp: any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
   
  }

  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.GetByIdEmployeeComplaints(this.userName);
    //this.GetEmployeeComplaintgridDetails(this.ItemsPerPage, this.pageno, this.l.EMP_EMPLOYEE_ID);
    this.route.params.subscribe(params => {
      this.COMPLAINT_ID = params['id'];
      this.mode = params['mode'];
      this.empId = params['empId'];
   
    
      if (this.COMPLAINT_ID > 0) {
        this.GetByIdComplaintDetails(this.COMPLAINT_ID);
      }

    if (this.mode == 'view') {
      this.hide = true;
      this.title = 'View Complaint Details'
    }

    if (this.mode == 'edit') {
      this.hide = true;
      this.title = 'Edit Complaint Details'
    }



    if ((this.empId) > 0) {
      this.EmployeeId = this.empId;
    }
    });
 
  }
  GetByIdEmployeeComplaints(userName) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdEmployeeComplaints(userName);
    this.data.subscribe(
      (response: any) => {
        this.l = response;
        // console.log(' a data :' + JSON.stringify(this.a));
         this.GetEmployeeComplaintgridDetails(this.ItemsPerPage, this.pageno, this.l.EMP_EMPLOYEE_ID);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    this.GetEmployeeComplaintgridDetails(itemsPerPage, pageNo, this.l.EMP_EMPLOYEE_ID);
    }
    pageChanged(pageNumber: number) {
    this.GetEmployeeComplaintgridDetails(this.ItemsPerPage, pageNumber, this.l.EMP_EMPLOYEE_ID);
    }
  GetEmployeeComplaintgridDetails(itemsPerPage: number, pageNo: number, empId:number) {
    // console.log('emp id :' + this.b.EMP_EMPLOYEE_ID);
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllComplaintDetailsForEmployee(itemsPerPage, pageNo, empId);
    this.data.subscribe(
    (response: any) => {
    console.log('leave data :' + JSON.stringify(response))
    this.EmployeeComplaintDetails = response.ComplaintRegisterModel;
    document.getElementById('loader-spinner').style.display = "none";
    },
    (error) => {
    document.getElementById('loader-spinner').style.display = "none";
    }
    );
    }
    GetByIdComplaintDetails(COMPLAINT_ID) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetByIdComplaintforEmployee(COMPLAINT_ID);
      this.data.subscribe(
        (response: any) => {
          this.b = response; 
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    UpdateComplaintAddress(ComplaintDetails: NgForm) {
      //debugger
      swal({
        title: 'Are you sure?', text: "You want to Update!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Update it!'
      }).then((result) => {
        if (result.value) {
  
          if (ComplaintDetails.invalid) {
            this.formInvalid = true;
            swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
            return;
          }
          else {
            // ComplaintDetails.value.EMP_ID = this.l.EMP_EMPLOYEE_ID;
            // ComplaintDetails.value.reply = this.Reply_Comp;
            this.data = this.userService.UpdateEmployeeComplaintDetails(ComplaintDetails.value,this.COMPLAINT_ID);
            this.data.subscribe(
              (response) => {
                ComplaintDetails.reset();
                ComplaintDetails.resetForm();
                ComplaintDetails.form.markAsPristine();
                ComplaintDetails.form.markAsUntouched();
                // this.resetFormFields();
                swal('Success!', 'Reply Successfully Submitted to BSHB.', 'success');
                this.router.navigate(['/home/emp-complaint']);
                // this.GetEmployeeComplaintgridDetails(this.ItemsPerPage, this.pageno, this.l.EMP_EMPLOYEE_ID);
                document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                if (error.status == 401) {
                  this.errorHandler.handleError(error);
                }
                else if (error.status == 400) {
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
          }
        }
      })
    }
    Cancel() {
      this.router.navigate(['/home/emp-complaint']);
    }
}



// WEBPACK FOOTER //
// ./src/app/hrms/emp-complaint/emp-complaint.component.ts